import { render, staticRenderFns } from "./fccOpcaoAlteracoes.vue?vue&type=template&id=52bb5662"
import script from "./fccOpcaoAlteracoes.vue?vue&type=script&lang=js"
export * from "./fccOpcaoAlteracoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports